import gql from "graphql-tag";

export default gql`
  mutation agentCreateCOD($create: paramsAgentCreateCOD) {
    agentCreateCOD(create: $create) {
      succeed
    }
  }
`;
